import { z } from 'zod/v4';

import { vehicleGroupStatsSchema } from './vehicle-group-stats.schema';

export const avoidFavorStatsSchema = z.object({
  totalCount: z.number(),
  unUsedAvoidFavors: z.array(
    z.object({
      setId: z.number(),
      name: z.string(),
      vehicleGroups: z.array(vehicleGroupStatsSchema),
      isDefault: z.boolean(),
    })
  ),
});

export type AvoidFavorStats = z.infer<typeof avoidFavorStatsSchema>;
